import { Routes } from '@angular/router';
import { riskManagerGuard } from '@core/guards/risk-manager.guard';

export const projectRoutes: Routes = [
  {
    path: 'projects/bulk-upload',
    loadComponent: () => import('./bulk-upload/bulk-upload.component').then(m => m.BulkUploadComponent),
    canActivate: [riskManagerGuard],
  },
  {
    path: 'projects/bulk-deactivate',
    loadComponent: () => import('./bulk-deactivation/project-bulk-deactivation.component').then(m => m.ProjectBulkDeactivationComponent),
    canActivate: [riskManagerGuard],
  },
  {
    path: 'projects',
    loadComponent: () => import('./projects.component').then(m => m.ProjectsComponent),
    canActivate: [riskManagerGuard],
  },
  {
    path: 'projects/new',
    loadComponent: () => import('./new-project/new-project.component').then(m => m.NewProjectComponent),
    canActivate: [riskManagerGuard],
  },
];
